import ReactDOM from 'react-dom/client';
import './Locals/i18n/i18n'
import { BrowserRouter } from 'react-router-dom';
import App from './App/App';
import { Provider } from 'react-redux';
import { store } from './Store/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Styles/index.css';

// Register service worker with better error handling
if ("serviceWorker" in navigator) {
  // Register immediately for better iOS compatibility
  navigator.serviceWorker
    .register("/sw.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
      
      // Check for updates
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              console.log("New service worker available");
            }
          });
        }
      });
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });

  // Also register on load for additional compatibility
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker re-registered on load");
      })
      .catch((error) => {
        console.error("Service Worker re-registration failed:", error);
      });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
      <ToastContainer
      autoClose={1500}
      hideProgressBar
      closeOnClick
      pauseOnHover={false}
      draggable
      position="top-right"
      toastClassName="toast" // Apply custom toast class globally
      bodyClassName="tostBody"
      closeButton={false}
      
    />
    </Provider>
  </BrowserRouter>
);




